import React from "react"
import { Div, Text } from "atomize"
import { theme } from "../settings/config"

// Pastiglia selezionabile: è la forma che l'app usa già per gli sport, i
// campi e i metodi di pagamento dentro le lezioni. `textColor` e
// `borderColor` sono quelli da accesa, per le pastiglie chiare (le
// situazioni di gioco nel contenuto della lezione) su cui il testo bianco
// non si leggerebbe; `badge` è un segno nell'angolo, come il pallino delle
// voci consigliate.
function Chip({ text, color, textColor, borderColor, isSelected, onClick, disabled, badge }) {
	const activeColor = color ?? theme.colors.gunmetal_fill

	return (
		<Div
			d="flex"
			align="center"
			p="0.25rem 0.75rem"
			w="fit-content"
			rounded="15px"
			border="2px solid"
			borderColor={isSelected ? borderColor ?? activeColor : theme.colors.surface}
			bg={isSelected ? activeColor : theme.colors.background}
			transition
			pos={badge ? "relative" : undefined}
			style={{ gap: "0.5rem", cursor: disabled ? "default" : "pointer" }}
			onClick={() => !disabled && onClick?.()}>
			<Text
				textSize="body"
				textWeight={isSelected ? "bold" : "normal"}
				textColor={isSelected ? textColor ?? theme.colors.white : theme.colors.text}>
				{text}
			</Text>
			{badge}
		</Div>
	)
}

export default Chip
